import type { RefObject } from 'react';

import { SharedState } from '@trello/shared-state';

export type OverlaysActiveState = {
  _activeOverlays: RefObject<HTMLDivElement | null>[];
  areOverlaysActive: boolean;
};

const initialOverlaysActiveState: OverlaysActiveState = {
  _activeOverlays: [],
  areOverlaysActive: false,
};

export const overlaysActiveState = new SharedState<OverlaysActiveState>(
  initialOverlaysActiveState,
);

export const addActiveOverlay = (
  ref: RefObject<HTMLDivElement | null>,
): void => {
  if (ref.current !== null) {
    overlaysActiveState.setValue((prevState): OverlaysActiveState => {
      const length = prevState._activeOverlays.push(ref);

      return {
        _activeOverlays: prevState._activeOverlays,
        areOverlaysActive: length > 0,
      };
    });
  }
};

export const removeActiveOverlay = (
  ref: RefObject<HTMLDivElement | null>,
): void => {
  overlaysActiveState.setValue((prevState): OverlaysActiveState => {
    const activeOverlays = prevState._activeOverlays.filter(
      (overlayRef) => overlayRef !== ref,
    );

    return {
      _activeOverlays: activeOverlays,
      areOverlaysActive: activeOverlays.length > 0,
    };
  });
};
